var map = {
	"./about_image.png": 370,
	"./bramble_co.png": 941,
	"./chords.jpg": 38,
	"./express.svg": 401,
	"./github.svg": 322,
	"./happy_bites.png": 993,
	"./hero_image.png": 861,
	"./hero_image.svg": 489,
	"./html5.svg": 577,
	"./js.svg": 410,
	"./mapbox.png": 522,
	"./mapbox.svg": 878,
	"./node.svg": 843,
	"./openfashion.jpg": 111,
	"./openfashion_v2.jpg": 632,
	"./playflix.jpg": 20,
	"./react.svg": 624,
	"./sass.svg": 265,
	"./stripe.svg": 896,
	"./twilio.svg": 779,
	"./wahaj.jpg": 434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;